import { defineStore } from "pinia";

export const useEvaluationStore = defineStore({
  id: "evaluation",
  state: () => ({
    lastViewedId: "",
  }),
  getters: {},
  actions: {}
});
